import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { Subscription } from 'rxjs';
@Component({
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  selector: 'app-expression-of-interest-view',
  templateUrl: './expression-of-interest-view.component.html',
  styleUrls: ['./expression-of-interest-view.component.css'],
})
export class ExpressionOfInterestViewComponent implements OnInit {
  projectIdNew: string;
  constructor(
    private projectsService: ProjectsService,
    public dialog: MatDialog,
    private GetProjectIdService: GetProjectIdService
  ) {}

  isDialogOpen = false;
  expressionData: any;
  private subscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.getExpressionOfInterest();
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.getExpressionOfInterest();
    });

    // this.getExpressionOfInterest();
  }
  getExpressionOfInterest() {
    this.projectsService.getProjectExpressions().subscribe({
      next: (data) => {
        this.expressionData = data.data[0];
        console.log('Expression of interest data fetched successfully:', data);
      },
      error: (error) => {
        console.error('Error fetching expression of interest data:', error);
      },
    });
  }
  closeDialog(): void {
    this.dialog.closeAll();
  }

  print() {
    this.closeDialog();
  }
}
